export default __webpack_public_path__ + "static/media/haiderWaheedAbout.621e6ed1.png";